import React, { useState } from 'react';
import styled from 'styled-components';
import nicholas from '../../images/nicholas.jpeg';
import karsh from '../../images/karsh.jpeg';
import walker from '../../images/walker.jpeg';

const TeamContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  background: transparent;
`;

const TeamWrapper = styled.div`
  max-width: 1100px;
  width: 100%;
  padding: 0 24px;
`;

const TeamCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-top: 20px;
  justify-items: center;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;

  @media screen and (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    max-width: 400px;
  }
`;

const TeamCard = styled.div`
  background: #010606;
  border: 2px solid #01BF71;
  border-radius: 10px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 300px;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(1, 191, 113, 0.3);
  }
`;

const TeamMemberImage = styled.img`
  width: 200px;
  height: 200px;
  border-radius: ${props => props.isCircular ? '50%' : '5px'};
  margin-bottom: 20px;
  object-fit: cover;
`;

const TeamMemberName = styled.h3`
  font-size: 1.5rem;
  color: #fff;
  margin-bottom: 10px;
  text-align: center;
`;

const TeamMemberRole = styled.p`
  font-size: 1rem;
  color: #01BF71;
  text-align: center;
`;

const BioOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
`;

const BioContent = styled.div`
  background: #010606;
  border: 2px solid #01BF71;
  border-radius: 10px;
  padding: 40px;
  max-width: 600px;
  width: 90%;
  position: relative;
  color: #fff;
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */

  @media screen and (max-width: 768px) {
    padding: 30px 20px;
    max-height: 80vh;
    margin: 20px;
    width: calc(100% - 40px);
  }
`;

const BioParagraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  color: #fff;

  &:last-child {
    margin-bottom: 0;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: #01BF71;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
  
  &:hover {
    color: #00a861;
  }
`;

const TeamSection = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
    { 
      name: 'Nicholas Pink',
      role: 'Marketing Operations Manager',
      image: nicholas,
      alt: 'Nicholas Pink - Marketing Operations Manager at Minute Growth',
      bio: `Nick is the founder of Minute Growth, where he combines technical marketing strategy with real-world business acumen to drive tangible results for clients. With a background spanning digital growth, brand building, and automation systems, Nick has scaled his agency to work with some of the most disruptive names in entertainment, e-commerce, and tech. Prior to founding Minute Growth, Nick worked in corporate operations at a Fortune 500 company, gaining a data-driven foundation that now powers the agency's elite performance tracking and client ROI frameworks. NEWLINEHERE Nick has helped creators turn brands into businesses, taken small teams to multi-six-figure revenue streams, and led large-scale public ad campaigns across Times Square and beyond. With a deep understanding of both creative and conversion, he brings a sharp edge to every campaign. His leadership ensures that Minute Growth's clients don't just grow fast, they grow smart.`,
    },
    { 
      name: 'Utkarsha "Karsh" Pandey',
      role: 'Social Media Marketing Specialist',
      image: karsh,
      alt: 'Utkarsha "Karsh" Pandey - Social Media Marketing Specialist at Minute Growth',
      bio: `Karsh leads the social media and blockchain strategy arm at Minute Growth. With a foundation in business administration and years of hands-on experience managing digital communities, Karsh brings a rare mix of strategic foresight and cultural fluency to the agency. He has overseen the development and execution of content strategies that have generated tens of millions of views, particularly in the high-growth niches of crypto, fintech, and online culture.NEWLINEHERE His strength lies in understanding algorithmic distribution and behavioral engagement across platforms like TikTok, Instagram, and X (formerly Twitter). Karsh has worked on campaigns that bridge traditional marketing with web3 innovation, crafting viral content strategies for NFT drops, crypto exchanges, and decentralized projects. For clients looking to stay ahead of digital shifts, Karsh ensures their messaging not only reaches, but resonates.`,
    },
    { 
      name: 'Walker Fleming',
      role: 'Public Ad and OOH Marketing Specialist',
      image: walker,
      alt: 'Walker Fleming - Public Ad and OOH Marketing Specialist at Minute Growth',
      bio: `Walker is a seasoned content creator turned public advertising strategist. Before joining Minute Growth, Walker amassed over 6 million followers on TikTok and 500,000+ on Instagram, making him one of the most recognizable creator names in his space. After retiring from life in front of the camera, he shifted focus to helping brands achieve the kind of reach and impact he built for himself. NEWLINEHERE At Minute Growth, Walker specializes in out-of-home (OOH) and public ad campaigns, securing placements in Times Square, urban transit systems, and viral physical activations. He brings an unmatched understanding of virality, creator psychology, and public attention dynamics. Whether it's working with talent or negotiating large-scale billboard buys, Walker ensures every campaign is built to turn heads and drive results, both online and offline.`,
    },
  ];

  const handleCardClick = (member) => {
    setSelectedMember(member);
  };

  const handleClose = () => {
    setSelectedMember(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <TeamContainer>
      <TeamWrapper>
        <TeamCards>
          {teamMembers.map((member, index) => (
            <TeamCard key={index} onClick={() => handleCardClick(member)}>
              <TeamMemberImage 
                src={member.image} 
                alt={member.alt}
                isCircular={index === 2} 
              />
              <TeamMemberName>{member.name}</TeamMemberName>
              <TeamMemberRole>{member.role}</TeamMemberRole>
            </TeamCard>
          ))}
        </TeamCards>
      </TeamWrapper>

      <BioOverlay isOpen={selectedMember !== null} onClick={handleOverlayClick}>
        {selectedMember && (
          <BioContent>
            <CloseButton onClick={handleClose}>&times;</CloseButton>
            <TeamMemberName>{selectedMember.name}</TeamMemberName>
            <TeamMemberRole>{selectedMember.role}</TeamMemberRole>
            {selectedMember.bio.split('NEWLINEHERE').map((paragraph, index) => (
              <BioParagraph key={index}>{paragraph.trim()}</BioParagraph>
            ))}
          </BioContent>
        )}
      </BioOverlay>
    </TeamContainer>
  );
};

export default TeamSection; 